import "./Header.css";
import Button from "../../../../../shared/components/Button/Button";
import Timer from "../../../../../shared/components/Timer/Timer";
import images from "../../../../../utilities/images/images";
import useAppHooks from "../../../../../shared/hooks/useAppHooks";

const Header = (props) => {
  const { onBack, onSubmit } = props;
  const { dispatch, selector } = useAppHooks();

  const state = selector((state) => state.examSlice);

  return (
    <div className="header-container">
      <div className="header-left" onClick={onBack}>
        <img src={images.leftArrow} alt="Back" className="back-icon" />
      </div>

      <div className="header-center">
        <Timer duration={state?.paper_duration} />
      </div>

      <div className="header-right">
        <Button
          title="Submit"
          variant="outlined"
          color="error"
          onClick={onSubmit}
          accessor="submit-btn"
          className="header-submit-btn"
        />
      </div>
    </div>
  );
};

export default Header;
